module.exports = __webpack_public_path__ + "img/pen.91c9f855.svg";